import React, { useEffect, useState } from "react";
import ConfirmationNumberFilter from "../../../common/components/filters/ConfirmationNumberFilter";
import EventFilter from "../../../common/components/filters/EventFilter";
import ButtonSearch from "../../../common/components/filters/ButtonSearch";
import { TransferDirectionSelect } from "../../enums/TransferDirectionEnum";
import { TransferStatusSelect } from "../../enums/TransferStatusEnum";
import TransferFilters from "../../types/TransferFilters";
import CityEventFilter from "../../../common/components/filters/CityEventFilter";

const TransferMeSearchForm = ({ onSearch, transfers }) => {
    const [query, setQuery] = useState<TransferFilters>({});
    const [transferCities, setTransferCities] = useState<any[]>([]);
    const [transferEvents, setTransferEvents] = useState<any[]>([]);

    // Extract unique events from transfers
    useEffect(() => {
        if (!transfers || transfers.length === 0) {
            setTransferEvents([]);
            return;
        }

        const uniqueById = (arr: any[]) => Array.from(new Map(arr.map(item => [item, item])).values());
        const events = transfers.map((transfer: any) => transfer.event);
        setTransferEvents(uniqueById(events));
    }, [transfers]);

    // Extract cities manually for transfers
    useEffect(() => {
        if (!transfers || transfers.length === 0) {
            setTransferCities([]);
            return;
        }

        const uniqueById = (arr: any[]) => Array.from(new Map(arr.map(item => [item, item])).values());
        const allCities = transfers.map(t => {
            return typeof t.cityEvent.city === 'object' ? t.cityEvent.city.id : t.cityEvent.city;
        });
        setTransferCities(uniqueById(allCities));
    }, [transfers]);

    // Trigger initial search on mount
    useEffect(() => {
        onSearch(query);
    }, [onSearch]);

    // Handle input changes
    const onChange = (updates: Partial<TransferFilters>) => {
        setQuery((prev) => ({
            ...prev,
            ...updates,
        }));
    };

    // Handle form submission
    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        onSearch(query);
    };

    return (
        <form
            onSubmit={handleSubmit}
            className="
                w-full relative mt-8 flex flex-col lg:flex-row lg:items-center
                lg:rounded-full shadow-xl dark:shadow-2xl bg-white dark:bg-neutral-800 bg-opacity-95
                [&>*]:w-full
                lg:[&>*]:max-w-[240px]
                lg:[&>*]:flex-1
            "
        >
            {/* Event Selector */}
            <EventFilter onChange={onChange} events={transferEvents} />
            {/* City Selector */}
            <CityEventFilter onChange={onChange} cities={transferCities} />
            {/* Direction Selector */}
            <TransferDirectionSelect onChange={onChange} value={query.direction} allowRoundTrip={false} />
            {/* Status Selector */}
            <TransferStatusSelect onChange={onChange} value={query.status} />
            {/* Confirmation Number Input */}
            <ConfirmationNumberFilter query={query} onChange={onChange} />

            {/* Search Button */}
            <div className="pl-2 lg:pl-0 pr-2 pb-4 lg:pb-0 xl:pr-4 w-full lg:w-auto flex justify-end lg:justify-center">
                <ButtonSearch type="submit" />
            </div>

        </form>
    );
};

export default TransferMeSearchForm;
